const LOCAL_STORAGE_KEY = {
  reconciliationDiscrepanciesReportYearMonth: 'reconciliationDiscrepanciesReportYearMonth',
};

Object.freeze(LOCAL_STORAGE_KEY);

export { LOCAL_STORAGE_KEY };
